export default () => `
  <div class="content">
    Please specify the weight of each ballast block you will be using to weigh down your ballast bays. 
    These are typically solid concrete blocks of standard size 2" x 8" x 16". 
    Check with your local supplier to see what sizes and weights might be available. Be sure the size you select will fit in the ballast bays. 
  </div>
`;
